import { ProgramSessionControllerApi } from "src/api/api";

export interface IWorkoutSessionApiClients {
    workoutSession: ProgramSessionControllerApi;
}

export class WorkoutSessionApiClients {
    private static instance: IWorkoutSessionApiClients;

    private constructor() { }

    static getInstance(basePath: string): IWorkoutSessionApiClients {
        if (WorkoutSessionApiClients.instance == null) {
            WorkoutSessionApiClients.instance = {
                workoutSession: new ProgramSessionControllerApi({
                    basePath: basePath,
                    isJsonMime() {
                        return true;
                    }
                }),
            };
        }
        return WorkoutSessionApiClients.instance;
    }
}

